import { apiUrl, prjName } from "./config";

export const bankDetails = async () => {
    try {
        const response = await fetch(`${apiUrl}/bankDetails?user=${prjName}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            }
        });

        const parsedData = await response.json();
        //  console.log("Parsed Bank ",parsedData)
        return parsedData;
    } catch (error) {
        console.log('Error:', error);
    }
};

export const updatesDetails = async (fromDate, toDate) => {
    try {
        const response = await fetch(`${apiUrl}/updateDetails?user=${prjName}&fromDate=${fromDate}&toDate=${toDate}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            }
        });

        const parsedData = await response.json();
        //  console.log("Parsed Updates ",parsedData)
        return parsedData;
    } catch (error) {
        console.log('Error:', error);
    }

};

export const feedbackDetails = async (data) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
        "user": prjName,
        "name": data?.name,
        "mobile": data?.mobile,
        "email": data?.email,
        "subject": data?.sub,
        "message": data?.message
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };

    try {

        const response = await fetch(`${apiUrl}/feedbackDetails`, requestOptions);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();

        return result;
    } catch (error) {
        console.error("An error occurred while fetching feedback details:", error);
        throw error;
    }

};

export const OTRDetails = async (data) => {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
        "user": prjName,
        "Name": data?.name,
        "FirmName": data?.firmname,
        "Mobile": data?.mobile,
        "City": data?.city,

    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
    };

    try {
        const response = await fetch(`${apiUrl}/otrDetails`, requestOptions);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();

        return result;
    } catch (error) {
        console.error("An error occurred while fetching feedback details:", error);
        throw error;
    }

};

export const KYCDetails = async (data) => {

    const formdata = new FormData();
    formdata.append("user", prjName);

    let copyFields = ["addressCopy", "panCopy", "gstCopy", "partnershipCopy"];

    Object.keys(data).forEach((key) => {
        if (copyFields.includes(key) && !!data[key]) {
            formdata.append("Files", data[key], data[key]["path"]);
        } else if (!!data[key]) {
            formdata.append(key, data[key]);
        }
    });

    const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
    };

    try {
        const response = await fetch(`${apiUrl}/kycDetails`, requestOptions);
        if (!response.ok) {
            // throw new Error('Network response was not ok');
            console.error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error) {
        console.error("An error occurred while fetching feedback details:", error);
        throw error;
    }

};